import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-[#FDFCF8] border-t border-stone-100" data-id="element-25">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-26">
        <div className="w-20 h-20 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-27">
          <ShieldCheck className="w-10 h-10 text-teal-600" data-id="element-28" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4" data-id="element-29">
          Zero Risk. Full Clarity.
        </h2>
        <p className="text-stone-600 leading-relaxed" data-id="element-30">
          Try the system for a full 60 days. If you don't create a bubble-free
          piece you love, send us a quick email and we'll refund every penny. No
          questions asked.
        </p>
      </div>
    </section>;
}